import {useSiteLanguage} from "../career/SiteLanguage";
import React, { useState, useEffect,useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";
import RegisterPopup from "../career/CareerRegister";
import EmailVerificationPopup from "../career/CareerRegister";
import ForgotPassword from "../career/CareerForgot";
import ReCAPTCHA from "react-google-recaptcha";

import { useCareerLanguage, careerRequest } from "../career/CareerLanguage";
import {sharedCandidateTarget} from "../career/sharedCandidateLink";
import {Mail,LockKeyhole} from 'lucide-react';
import {AuthShell,AuthField,AuthSubmit,AuthMessage,authError,focusAuthError} from '../career/CareerAuth';
import {emailConfirmationRequired,emailWaitSeconds} from '../career/CareerEmailVerification';

import WelcomeVideoPopup from "./WelcomeVideoPopup";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiArrayGetir = (value) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.$values)) return value.$values;
  return [];
};

const kullaniciShiftYetkiliMi = (user) => {
  const permissionCodes = apiArrayGetir(user?.permissionCodes).map((x) =>
    String(x).trim().toLowerCase()
  );

  const deniedPermissionCodes = apiArrayGetir(user?.deniedPermissionCodes).map((x) =>
    String(x).trim().toLowerCase()
  );

  const shiftIzniVar = permissionCodes.includes("shift.yonetimi");
  const shiftIzniEngelliMi = deniedPermissionCodes.includes("shift.yonetimi");

  return shiftIzniVar && !shiftIzniEngelliMi;
};

export default function Login({ onClose }) {
  const {tx} = useSiteLanguage();
  const {t,lang,change} = useCareerLanguage();
  const navigate = useNavigate();

  // 👇 Hoşgeldin videosu state
  const [showWelcomeVideo, setShowWelcomeVideo] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showRegisterPopup, setShowRegisterPopup] = useState(false);
  const [showVerificationPopup, setShowVerificationPopup] = useState(false);
  const [verificationEmail,setVerificationEmail]=useState('');
  const [verificationResendSeconds,setVerificationResendSeconds]=useState(0);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [captchaSize,setCaptchaSize]=useState(()=>window.innerWidth<=650?'compact':'normal');
  useEffect(()=>{
    const media=window.matchMedia?.('(max-width:650px)');
    const update=()=>setCaptchaSize((media?media.matches:window.innerWidth<=650)?'compact':'normal');
    update();media?.addEventListener?.('change',update);window.addEventListener('resize',update);
    return()=>{media?.removeEventListener?.('change',update);window.removeEventListener('resize',update);};
  },[]);
  useEffect(()=>setCaptchaVerified(false),[captchaSize,lang]);
  const [rememberMe, setRememberMe] = useState(false);
  const [fieldErrors,setFieldErrors]=useState({});
  const loadingRef=useRef(false);

  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  // 🔁 Login sonrası sayfaya geçiş fonksiyonu
  const proceedToApp = async () => {
    let targetPath = "/profil";
    const shareTarget=sharedCandidateTarget(window.location.search);
    if(shareTarget&&localStorage.getItem('userRole')==='personel'){
      navigate(shareTarget);onClose();return;
    }
    try { const profile=await careerRequest();await change(profile.dil,false);if(profile.ilkGirisFormuGerekli)targetPath="/ozgecmisim"; }
    catch { setError(t('error'));return; }

    navigate(targetPath);

    setTimeout(() => {
      onClose();
      window.location.reload();
    }, 1000);
  };



  // 📺 Login başarılı olduktan sonra hoşgeldin videosu kontrolü
  const checkWelcomeVideo = async (token) => {
    try {const profile=await careerRequest();if(profile.ilkGirisFormuGerekli){await proceedToApp();return;}}catch{setError(t('error'));return;}
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/GirisVideo/kullanici/hepsi`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const list =
        res.data.$values ||
        res.data.values ||
        res.data.sValues ||
        res.data ||
        [];

      // Sadece hoşgeldin videosunu bul
      const kayit = list.find((item) => String(item.videoId) === "1");

      console.log("👉 GirisVideo kayit:", kayit);

      if (!kayit) {
        // 1️⃣ Hiç kayıt yok → ilk giriş
        await axios.post(
          `${API_BASE_URL}/api/GirisVideo/ekle`,
          {
            videoAdi: "hosgeldin",
            videoId: "1",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Kayıt açıldı, videoyu göster
        setShowWelcomeVideo(true);
        return;
      }

      // 2️⃣ Kayıt var → izledi & birdahaSorma kontrolü
      const izledi = kayit.izledi === true;              // ❗ DİKKAT: izledi
      const birdahaSorma = kayit.birdahaSorma === true;  // ❗ aynen böyle

      console.log("izledi:", izledi, "birdahaSorma:", birdahaSorma);

      if (izledi && birdahaSorma) {
        // ✅ Video tam izlenmiş ve bir daha sorma denmiş → video açma
        proceedToApp();
      } else {
        // ❗ Yarım kalmış veya birdahaSorma false → tekrar video oynat
        setShowWelcomeVideo(true);
      }
    } catch (err) {
      console.error("GirisVideo kontrol hatası:", err);
      // Hata olursa yine uygulamaya al
      proceedToApp();
    }
  };


  // Login popup açıldığında kayıtlı login bilgisi varsa doldur
  useEffect(() => {
    const savedEmail = localStorage.getItem("loginEmail");
    localStorage.removeItem("loginPassword");
    if (savedEmail) {
      setEmail(savedEmail);
      localStorage.removeItem("loginPassword");
      setRememberMe(true);
    }
  }, []);

  // Eski kayıtlı login bilgilerini temizleme (senin kodundan)
  useEffect(() => {
    localStorage.removeItem("loginPassword");
  }, []);

  const handleLogin = async () => {
    if(loadingRef.current)return;
    setError("");
    const issues={};if(!email.trim())issues.identifier=t('authRequired');if(!password)issues.password=t('authRequired');
    setFieldErrors(issues);if(Object.keys(issues).length){focusAuthError(issues,'ca-login-');return;}

    const isDevelopment =
      window.location.hostname === "localhost" ||
      window.location.hostname.startsWith("192.168.");

    if (!captchaVerified && !isDevelopment) {
      setError(tx("⚠️ Lütfen 'Ben robot değilim' doğrulamasını tamamlayın."));
      setLoading(false);
      return;
    }
    loadingRef.current=true;
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Auth/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            identifier: email.trim(),
            password,
            saglayiciId: "0",
          }),
        }
      );

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        data = { message: text };
      }

      if (response.status === 200) {
        const token = data.token?.result || data.token;
        const user = data.user;

        const permissionCodes = apiArrayGetir(user?.permissionCodes);
        const deniedPermissionCodes = apiArrayGetir(user?.deniedPermissionCodes);
        const shiftYetkisiVar = kullaniciShiftYetkiliMi(user);

        localStorage.setItem(
          "token",
          typeof token === "string" ? token : JSON.stringify(token)
        );

        localStorage.setItem("user", JSON.stringify(user));

        localStorage.setItem("userName", user?.adi || "");
        localStorage.setItem("userSurname", user?.soyadi || "");
        localStorage.setItem("userEmail", user?.email || "");

        localStorage.setItem("authData", JSON.stringify(data));

        localStorage.setItem(
          "permissionCodes",
          JSON.stringify(permissionCodes)
        );

        localStorage.setItem(
          "deniedPermissionCodes",
          JSON.stringify(deniedPermissionCodes)
        );

        localStorage.setItem(
          "shiftYetkisiVar",
          shiftYetkisiVar ? "true" : "false"
        );

        // Mail sessions are opened on demand and kept only in memory.
        localStorage.removeItem("mailboxEmail");
        localStorage.removeItem("mailSessionId");

        if (rememberMe) {
          localStorage.setItem("loginEmail", email.trim());
          localStorage.removeItem("loginPassword");
        } else {
          localStorage.removeItem("loginEmail");
          localStorage.removeItem("loginPassword");
        }

        // 🔐 Rol bilgisi al
        try {
          const rolResponse = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/api/Rol/benimrollerim`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          const rolData = await rolResponse.json();
          const roller = apiArrayGetir(rolData);

          localStorage.setItem("roles", JSON.stringify(roller));

          const mudurErisimResponse = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/api/mudur/egitim-dashboard/erisim`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const mudurErisimData = mudurErisimResponse.ok
            ? await mudurErisimResponse.json()
            : { erisimVar: false };
          localStorage.setItem(
            "magazaMuduruMu",
            mudurErisimData?.erisimVar === true ? "true" : "false"
          );

          try {
            const ilanErisimResponse = await fetch(
              `${process.env.REACT_APP_API_BASE_URL}/api/mudur/ilanlar/erisim`,
              { headers: { Authorization: `Bearer ${token}` } }
            );
            const ilanErisimData = ilanErisimResponse.ok
              ? await ilanErisimResponse.json()
              : { erisimVar: false };
            localStorage.setItem(
              "ilanPaylasimErisimiVar",
              ilanErisimData?.erisimVar === true ? "true" : "false"
            );
          } catch {
            localStorage.setItem("ilanPaylasimErisimiVar", "false");
          }

          const personelRoller = [
            "Personel",
            "MagazaMudurYardimcisi",
            "MagazaMuduru",
            "AlanMuduru",
            "BolgeMuduru",
          ];
          let userRole = "yetkisiz";

          if (roller.some((r) => personelRoller.includes(r))) {
            userRole = "personel";
          }
          if (userRole === "yetkisiz" && roller.includes("Aday")) {
            userRole = "aday";
          }

          localStorage.setItem("userRole", userRole);
        } catch (rolError) {
          console.error("Rol alınamadı:", rolError);
          localStorage.removeItem("roles");
          localStorage.setItem("magazaMuduruMu", "false");
          localStorage.setItem("ilanPaylasimErisimiVar", "false");
          localStorage.setItem("userRole", "yetkisiz");
        }

        const kanGrubuEksik =
          user?.kanGrubu === null ||
          user?.kanGrubu === "" ||
          user?.needKanGrubu === true;

        if (kanGrubuEksik) {
          sessionStorage.setItem("showKanGrubuPopup", "true");
        }
        await checkWelcomeVideo(token);

      } else if (response.status === 400) {
        const targetEmail=(typeof data?.email==='string'?data.email:email).trim();
        if(emailConfirmationRequired(data)&&/^[^\s@]+@[^\s@]+$/.test(targetEmail)){
          setVerificationEmail(targetEmail);
          setVerificationResendSeconds(emailWaitSeconds(data));
          setShowVerificationPopup(true);
        }else{
          setError(await authError({status:response.status,text:async()=>text},t,'authLoginFailed'));
        }
      } else if (response.status === 401) {
        setError(t('authLoginFailed'));
      } else {
        // The response text was already consumed above. Do not expose server traces.
        setError(await authError({status:response.status,text:async()=>text},t,'authLoginFailed'));
      }
    } catch (err) {
      setError(t('authNetworkError'));
    } finally {
      loadingRef.current=false;
      setLoading(false);
    }
  };

  return (
    <>
      {/* 🎥 Hoşgeldin Videosu Popup */}
      <WelcomeVideoPopup
        isOpen={showWelcomeVideo}
        onClose={() => {
          setShowWelcomeVideo(false);
          proceedToApp();
        }}
      />

      {!showRegisterPopup && !showVerificationPopup && !showForgotPassword && !showWelcomeVideo && (
       <AuthShell title={t('login')} intro={t('authLoginIntro')} busy={loading} onClose={onClose} mode="login" onLogin={()=>{}} onRegister={()=>{setError('');setShowRegisterPopup(true);}}>
        <form className="ca-form" noValidate aria-busy={loading} onSubmit={e=>{e.preventDefault();handleLogin();}}>
         <AuthField id="ca-login-identifier" label={t('authIdentifier')} icon={Mail} required disabled={loading} maxLength={256} autoComplete="username" value={email} error={fieldErrors.identifier} data-auth-autofocus onChange={e=>{setEmail(e.target.value);setFieldErrors(x=>({...x,identifier:''}));setError('');}}/>
         <AuthField id="ca-login-password" label={t('password')} icon={LockKeyhole} password required disabled={loading} autoComplete="current-password" value={password} error={fieldErrors.password} onChange={e=>{setPassword(e.target.value);setFieldErrors(x=>({...x,password:''}));setError('');}}/>
         <div className="ca-login-options"><label className="ca-remember"><input type="checkbox" checked={rememberMe} disabled={loading} onChange={e=>setRememberMe(e.target.checked)}/>{t('remember')}</label><button type="button" className="ca-link" disabled={loading} onClick={()=>setShowForgotPassword(true)}>{t('forgot')}</button></div>
         {!(window.location.hostname==='localhost'||window.location.hostname.startsWith('192.168.'))&&<div className="ca-captcha"><ReCAPTCHA key={lang+'-'+captchaSize} size={captchaSize} sitekey={siteKey} onChange={value=>setCaptchaVerified(Boolean(value))} onExpired={()=>setCaptchaVerified(false)} onErrored={()=>setCaptchaVerified(false)} hl={lang}/></div>}
         <AuthMessage error={error}/><AuthSubmit busy={loading} label={t('login')}/>
        </form>
        <footer className="ca-footer"><span>{t('authNoAccount')}</span><button type="button" className="ca-link" disabled={loading} onClick={()=>{setError('');setShowRegisterPopup(true);}}>{t('register')}</button></footer>
       </AuthShell>
      )}

      {showRegisterPopup && !showVerificationPopup && (
        <RegisterPopup
          onClose={onClose}
          openLoginPopup={(email) => {
            setEmail(email);
            setShowRegisterPopup(false);
          }}
        />
      )}

      {showVerificationPopup && (
        <EmailVerificationPopup
          email={verificationEmail}
          resendAfterSeconds={verificationResendSeconds}
          resumeVerification
          onClose={onClose}
          openLoginPopup={()=>setShowVerificationPopup(false)}
          onSuccess={() => {
            setShowVerificationPopup(false);
            setTimeout(() => {
              handleLogin();
            }, 1000);
          }}
        />
      )}

      {showForgotPassword && (
        <ForgotPassword onClose={onClose} onBack={()=>setShowForgotPassword(false)} />
      )}
    </>
  );
}
